/*
 * What every API client does with a 401.
 *
 * It used to clear the session and send the browser to /login, unconditionally
 * and from all twenty clients. That was right while the whole app was
 * members-only. It is wrong now that pages are public: a guest opening
 * /labs/local-cloud triggers a progress request they have no right to make,
 * the 401 comes back, and the interceptor ejects them to a login screen they
 * never asked for. The page was open; the background call was not.
 *
 * So the redirect is now conditional on there having been a session at all. An
 * expired one still bounces, which is the behaviour that matters. A visitor
 * who never signed in is left where they were, and the calling code handles
 * the rejected promise — all of these already catch it.
 */
export function handle401(err) {
  if (err?.response?.status !== 401) return;
  const hadSession = !!localStorage.getItem('lxops_token');
  localStorage.removeItem('lxops_token');
  localStorage.removeItem('lxops_user');
  if (hadSession) window.location.href = '/login';
}
